import { css, Interpolation, Theme } from '@emotion/react'

export const title: Interpolation<Theme> = (theme) => css`
  font-weight: 700;
  font-size: 22px;
  line-height: 28px;
  color: ${theme.typographyColors.typographyTwo};
  margin: 30px 0 24px;
`

export const tabContent = (isVisible?: boolean) => css`
  display: ${isVisible ? 'flex' : 'none'};
  flex-direction: column;
  justify-content: space-between;
  gap: 24px;
`
